// extracted by mini-css-extract-plugin
export default {"grid-container":"pjMGagAz7egRiBs05Xai"};